import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Profile} from 'src/app/model/profile';
import {CommonMessagesService} from 'src/app/services/common-messages.service';
import {ProfilesService} from 'src/app/services/profiles.service';

@Component({
  selector: 'app-delete-profile-dialog',
  templateUrl: './delete-profile-dialog.component.html',
  styleUrls: ['./delete-profile-dialog.component.scss']
})
export class DeleteProfileDialogComponent {

  @Input() visible: boolean;
  @Input() profile: Profile;
  @Input() profiles: Profile[];

  @Output() onClose: EventEmitter<{ success: boolean }> = new EventEmitter<{ success: boolean }>();

  public selectedProfileUuid: string;


  constructor(
    private profilesService: ProfilesService,
    private commonMessagesService: CommonMessagesService
  ) {
  }

  deleteAndReassignProfile(): void {
    const profileUuid = this.profile.profileUuid;
    const profileToReassignUuid = this.selectedProfileUuid;
    this.profilesService.deleteAndReassignProfile(profileUuid, profileToReassignUuid).toPromise().then(() => {
      this.onClose.emit({success: true});
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  closeDialog(): void {
    this.onClose.emit({success: false});
    this.visible = false;
  }

}
